import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faEraser } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Ayacucho from "../../../images/modulo14/ayacucho.png";
import { ReactSketchCanvas } from "react-sketch-canvas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad1.mp3";

const styles = {
  height: "780px",
  background: `url(${Ayacucho})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
};

const Actividad2 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[0];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[1].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[1].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[11].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[11].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
        <AudioPlayer track={Audio} />

      <div className="row my-4">
        <div className="col-md-4">
          <ul>
            <li>
              Lo que ves en la imagen es un día cualquiera en un poblado de
              Ayacucho. La mayoría de los vecinos del lugar hablan quechua y
              castellano, pero algunos solo hablan quechua.
            </li>
            <li>
              Encierra en un círculo los lugares donde crees que es necesario
              que se atienda a las personas tanto en quechua como en castellano.
            </li>
          </ul>
        </div>
        <div className="col-md-8">
          <ReactSketchCanvas
            ref={canvasEl}
            style={styles}
            width="600"
            height="100%"
            strokeWidth={4}
            strokeColor={"red"}
          />
          <div className="d-flex mt-1 justify-content-end w-100">
            <button
              onClick={activateEraser}
              className={`btn btn-green me-1 ${
                eraseMode ? "active" : "inactive"
              }`}
            >
              Borrador <FontAwesomeIcon icon={faEraser} />
            </button>
            <button
              onClick={activatePen}
              className={`btn btn-green me-1 ${
                penMode ? "active" : "inactive"
              }`}
            >
              Lapiz <FontAwesomeIcon icon={faPen} />
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que esta unidad busca reflexionar sobre
            lo que significa que en el Perú se hable una gran variedad de
            lenguas. Si bien es un signo de riqueza cultural, como veremos,
            también representa un gran reto. Las primeras actividades buscan que observen una imagen a partir de la cual deben de dar
            información.
          </li>
          <li>
            Pida que en silencio observen la imagen que se
            presenta. Pregunte: ¿Qué observan en ella? Recoja sus respuestas y
            retómelas:
            <ul>
              <li>
                <i>
                  “Vemos una ciudad en la que hay una escuela, comisaría, posta
                  médica, municipalidad, mercado y un locutorio. Se ve
                  movimiento, gente que camina, conversa. Hay una persona
                  entrando al mercado, otra a la escuela. Alguien se acerca a la
                  comisaría y habla con un policía, igual en la municipalidad.
                  También hay personas lavando ropa, gente en la Casa Comunal y
                  el Comedor Popular”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea las dos indicaciones: Lo que ves en la imagen es un día
            cualquiera en un poblado de Ayacucho. La mayoría de los vecinos del
            lugar hablan quechua y castellano, pero algunos solo hablan quechua.
            Encierra en un círculo los lugares donde crees que es necesario que
            se atienda a las personas tanto en quechua como en castellano.
          </li>
          <li>
            Dé un tiempo para que trabajen. Pregunte qué lugares encerraron con un círculo. Pregunte por qué
            creen que en esos lugares se necesita tanto el quechua como el
            castellano. Luego pregunte por los lugares que no fueron encerrados
            en un círculo, por qué creen que allí no se necesitan los dos
            idiomas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
